
import { en } from "./en";

type Translation = typeof en;

export const pl: Translation = {
  common: {
    close: "Zamknij",
    copy: "Kopiuj",
    copied: "Skopiowano",
    news: "Wiadomości",
    more: "Więcej",
    success: "Sukces",
    failed: "Niepowodzenie",
    page: "Strona",
    of: "z",
    loading: "Ładowanie...",
    error: "Błąd",
    search: "Szukaj",
    reset: "Resetuj",
    filter: "Filtruj",
    details: "Szczegóły",
    no_results: "Nie znaleziono wyników",
    no_description: "Brak dostępnego opisu",
    back: "Wróć",
    deselect_all: 'Odznacz wszystko',
    select_all: 'Zaznacz wszystko',
  },
  navbar: {
    news: "Aktualności",
    leaks: "Wycieki",
    cve: "CVE",
    ransomware: "Ransomware",
    eol: "EOL",
    releases: 'Wydania',
    dashboard: 'Dashboard',
  },
  index: {
    title: "CyberMonit - Bądź na bieżąco z zagrożeniami cyberbezpieczeństwa",
    description: "CyberMonit to platforma do monitorowania i analizowania zagrożeń cyberbezpieczeństwa. Zbieramy dane z różnych źródeł, aby dostarczyć Ci najbardziej aktualne informacje o wyciekach, lukami, ransomware i końcu życia oprogramowania.",
    latest_news: "Najnowsze wiadomości",
    leaks: "Wycieki",
    cve: "CVE",
    ransomware: "Ransomware",
    eol: "EOL",
  },
  news: {
    title: "Najnowsze Aktualności",
    sources: "Źródła Wiadomości",
    loading: "Ładowanie wiadomości...",
    error: "Błąd ładowania wiadomości",
    readMore: "Czytaj więcej",
    page: "Strona",
    of: "z",
    pageTitle: "Najnowsze Informacje z Cyberbezpieczeństwa",
  },
  leaks: {
    title: "Najnowsze wycieki danych",
    subtitle: "Monitoruj najnowsze wycieki danych i naruszenia bezpieczeństwa.",
    searchPlaceholder: "Szukaj wycieków...",
    noLeaks: "Nie znaleziono wycieków.",
    domain: "Domena",
    no_domain: "Nieznane źródło",
    dataTypes: "Rodzaje danych",
    details: 'Zobacz szczegóły',
    breach_stats: 'Statystyki wycieku',
    records: 'Rekordów',
    data_types: 'Typy danych',
    description: 'Opis',
    close: "Zamknij",
    loading: "Ładowanie wycieków...",
    error: "Błąd ładowania wycieków",
    searchResults: "Znaleziono {count} wyników",
    noResults: "Nie znaleziono wycieków spełniających kryteria",
    resetFilters: "Resetuj filtry",
    pageTitle: "Baza Wycieków Danych",
  },
  cve: {
    title: "Baza Danych CVE",
    subtitle: "Przeszukuj bazę podatności CVE",
    searchPlaceholder: "Szukaj CVE (np. CVE-2023-4863)",
    clearSearch: "Wyczyść wyszukiwanie",
    searching_progress: "Wyszukiwanie w toku...",
    noSearchResults: "Brak wyników wyszukiwania",
    searchResults: "Znaleziono {count} wyników",
    year_selector: "Rok",
    year_selector_description: "Wybierz rok CVE",
    filter: "Filtr Ważności",
    'filter.critical': "Krytyczne",
    'filter.high': "Wysokie",
    'filter.medium': "Średnie",
    'filter.low': "Niskie",
    current_year: "Bieżący Rok",
    details: "Zobacz szczegóły",
    score: "Ocena",
    close: "Zamknij",
    search_all_years: "Przeszukaj Wszystkie Lata",
    loading_year: "Ładowanie danych z roku {year}...",
    more_years: "Więcej Lat",
    show_stats: "Pokaż Statystyki",
    hide_stats: "Ukryj Statystyki",
  },
  ransomware: {
    title: "Ataki Ransomware",
    description: "Bądź na bieżąco z najnowszymi atakami ransomware i chroń swoje dane.",
    subtitle: "Śledź i monitoruj najnowsze ataki ransomware w różnych krajach i sektorach",
    countryFilter: "Filtr Krajów",
    searchPlaceholder: "Szukaj ataków...",
    showFilter: "Pokaż Filtry",
    details: "Zobacz szczegóły",
    close: "Zamknij",
    noSearchResults: "Nie znaleziono ataków ransomware",
    resetFilters: "Resetuj Filtry",
    filterInstructions: "Wybierz kraje, aby filtrować ataki",
    selectAll: "Zaznacz Wszystkie",
    deselectAll: "Odznacz Wszystkie",
    other: "Inne",
    hideFilter: "Ukryj Filtry",
    searchResults: "Znaleziono {count} wyników",
    noFilteredResults: "Żadne ataki nie pasują do obecnych filtrów",
    showingCountries: "Pokazywanie ataków z {count} krajów",
    loading: "Ładowanie danych ransomware...",
    showingResultsFor: "Pokazywanie wyników dla",
    no_attacks_recorded: "Nie odnotowano ataków ransomware",
    top_targets: "Główne Cele",
    attacks: "Ataki",
    victims: "Ofiary",
  },
  eol: {
    title: "Oprogramowanie z zakończonym wsparciem",
    subtitle: "Śledź oprogramowanie, które osiągnęło koniec życia i może stanowić zagrożenie dla bezpieczeństwa",
    description: "Śledź oprogramowanie, które osiągnęło koniec życia i może stanowić zagrożenie dla bezpieczeństwa.",
    searchPlaceholder: "Szukaj oprogramowania...",
    details: "Zobacz szczegóły",
    daysRemaining: "Pozostało dni",
    expired: "Wygasło",
    lts: "LTS",
    no: "Nie",
    latestReleaseDate: "Data najnowszego wydania",
    releaseDate: "Data wydania",
    eolDate: "Data końca wsparcia",
    latestVersion: "Najnowsza wersja",
    pageTitle: "Śledzenie Oprogramowania z Zakończonym Wsparciem",
    all: "Wszystkie",
    sortName: "Sortuj według Nazwy",
    clearFilters: "Wyczyść Filtry",
    loading: "Ładowanie danych EOL...",
    version: "Wersja",
    sortEOL: "Sortuj według daty EOL",
    searchResults: "Znaleziono {count} wyników",
    statusActive: "Aktywne",
    statusWarning: "Ostrzeżenie",
    statusExpired: "Wygasłe",
  },
  themeToggle: {
    light: "Jasny",
    dark: "Ciemny",
    system: "Systemowy",
  },
  languageToggle: {
    pl: 'Polski',
    en: 'Angielski',
    change: 'zmień język',
  },
  footer: {
    made_by: "Stworzone przez",
    source_code: "Kod źródłowy",
    rights: "Wszelkie prawa zastrzeżone",
  },
  releases: {
    title: 'Wydania Oprogramowania',
    description: 'Śledź najnowsze wydania i aktualizacje oprogramowania z Twoich ulubionych projektów.',
    search_placeholder: 'Szukaj projektów...',
    clear_search: 'Wyczyść wyszukiwanie',
    searching: 'Wyszukiwanie...',
    search_results: 'Znaleziono {count} wyników',
    no_results: 'Nie znaleziono projektów spełniających kryteria wyszukiwania',
    no_data: 'Brak dostępnych danych o wydaniach',
    error_title: 'Nie udało się załadować danych o wydaniach',
    error_description: 'Wystąpił błąd podczas ładowania danych o wydaniach. Spróbuj ponownie później.',
    error_toast: 'Nie udało się załadować danych o wydaniach',
    github_repository: 'Repozytorium Github',
    pageTitle: 'Najnowsze Wydania Oprogramowania',
    release_date: 'Wydano',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Kluczowe wskaźniki i statystyki cyberbezpieczeństwa z ostatnich {days} dni',
    pageTitle: 'Dashboard Cyberbezpieczeństwa',
    description: 'Zobacz kluczowe wskaźniki i statystyki cyberbezpieczeństwa z ostatnich 30 dni',
    ending_support: 'Kończące się wsparcie',
    data_leaks: 'Wycieki Danych',
    active_group: 'Najaktywniejsza Grupa Ransomware',
    ransomware_victims: 'Ofiary Ransomware',
    critical_vulnerabilities: 'Krytyczne Podatności',
    high_vulnerabilities: 'Wysokie Podatności',
    medium_vulnerabilities: 'Średnie Podatności',
    low_vulnerabilities: 'Niskie Podatności',
    last_days: 'Ostatnie {days} dni',
    most_attacked_country: 'Najczęściej atakowany kraj',
    latest_news: 'Najnowsze Wiadomości',
    recent_leaks: 'Ostatnie Wycieki Danych',
    critical_vulnerabilities_recent: 'Najnowsze Krytyczne Podatności',
    upcoming_eol: 'Oprogramowanie Wkrótce bez Wsparcia',
    latest_releases: 'Najnowsze Wydania',
    latest_ransomware: 'Najnowsze Ataki Ransomware',
    ransomware_recent: 'Najnowsze Ataki Ransomware', // Keep this for backward compatibility
    global_ransomware_activity: 'Globalna Aktywność Ransomware',
  },
};
